// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;He shall have pity on the weak and poor;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;he shall preserve the lives of the needy.<br> </p> </div></div>";
// Exports
module.exports = code;